import React, {Component} from "react";
import FaqCard from "./faqCard";
import FaqData from "./faqData";

class FAQ extends Component{

    constructor(props){
        super(props);
        this.state = {
            style : {
                textAlign : "center",
            }
        }
    }
    render(){
        return(

            <div className="breadcrumb-area">
                <div>
                    <h2 style={this.state.style}>FAQs</h2>

                    {FaqData.map((item) => <FaqCard key={item.id} Question={item.Question} Answer={item.Answer} />)}

                </div>
            </div>
        )
    }
}

export default FAQ;